// extracted by mini-css-extract-plugin
export var distance = "search-tolerance-module--distance--1PKpe";
export var highlight = "search-tolerance-module--highlight--2aa9h";
export var itemImg = "search-tolerance-module--item-img--2Llr6";
export var levenshteinOn = "search-tolerance-module--levenshtein-on--1Q9wz";
export var searchContainer = "search-tolerance-module--search-container--aYYBO";
export var searchList = "search-tolerance-module--search-list--EpVNk";